export const fadeOnScroll = () => {
	const elsToFade = [].slice.call(document.querySelectorAll('.js-fade-in'));

	if ( elsToFade.length ) {
        const lazyFadeObserver = new IntersectionObserver(initFadeInElem, {
			threshold: 0.1,
		});

        elsToFade.forEach(elem => {
            lazyFadeObserver.observe(elem);
        });
    }
	//Check for all instances of that element on the page
	/* let elementsToFade = [];
	let allElementsFound = [];

	if (elsToFade) {
		elsToFade.forEach((el) => {
			allElementsFound = [].slice.call(el)
			elementsToFade = elementsToFade.concat(allElementsFound);
		});
	} */

	/* //Make sure we can use intersection observer
	if ("IntersectionObserver" in window) {
		//Create an observer to add the fade in class
		var lazyFadeObserver;
		lazyFadeObserver = new IntersectionObserver(function (entries, observer) {
			entries.forEach(function (fadeEl) {
				if (fadeEl.isIntersecting) {

					//Add the fade in class
					setTimeout(() => {
						fadeEl.target.classList.add('fade-in');
					}, 250);

					//Remove this map from the observer, as it's now loaded in
					lazyFadeObserver.unobserve(fadeEl.target);
				}
			});
		}, {
			threshold: 0.1,
		});

		//Add the fade elements to the observer
		if (lazyFadeObserver) {
			elementsToFade.forEach((el) => {
				lazyFadeObserver.observe(el);
			});
		}
	} */
}

const initFadeInElem = (entries, observer) => {
    entries.forEach(fadeEl => {
        if ( fadeEl.isIntersecting ) {
			//Add the fade in class
			setTimeout(() => {
				fadeEl.target.classList.add('fade-in');
			}, 250);

			//Remove this map from the observer, as it's now loaded in
			observer.unobserve(fadeEl.target);
        }
    });
};